import { loadScript, getCurrentRegion } from "/Assets/js/common/utilities.js";

document.addEventListener("DOMContentLoaded", function () {
    const mediaGalleryElements = document.querySelectorAll(".media-gallery");

    if (mediaGalleryElements.length > 0) {
        const hasYouTubeSlides = document.querySelectorAll(".youtube-slide").length > 0;
        const shouldLoadYouTube = hasYouTubeSlides && getCurrentRegion() !== "China";

        const initializeGalleries = () => {
            import(/* webpackChunkName: "media-gallery" */ "/Features/MediaGallery/js/media-gallery-vanilla.js").then((module) => {
                mediaGalleryElements.forEach((element) => {
                    const mediaGallery = new module.default(element);
                    mediaGallery.init();
                });
            });
        };

        if (shouldLoadYouTube) {
            // Set up YouTube callback
            window.onYouTubeIframeAPIReady = () => {
                initializeGalleries();
            };
            loadScript("https://www.youtube.com/iframe_api");
        } else {
            initializeGalleries();
        }
    }
});